// `broadcast.sent.v1` — emitted by marketing-backend when a broadcast
// finishes its final send step (CAMPAIGN: scheduled send completed; TRIGGER:
// the per-recipient automation flushed).
//
// Downstream consumers (contacts-db-backend, analytics) listen to keep
// engagement counters in sync. Marketing-backend is the PRODUCER.
//
// detailType in EventBridge: `broadcast.sent.v1` (Commitment 6).

import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const broadcastSentV1Schema = eventEnvelopeSchema.extend({
  broadcastId: z.string().uuid(),
  broadcastType: z.enum(['CAMPAIGN', 'TRIGGER']),
  recipientCount: z.number().int().nonnegative(),
});

export type BroadcastSentV1 = z.infer<typeof broadcastSentV1Schema>;

export const BROADCAST_SENT_V1_DETAIL_TYPE = 'broadcast.sent.v1' as const;
